import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
  FirstName: "",
  LastName: "",
  HospitalID: "",
  selectedPatient: "",
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    setValue: (state, action) => {
      state.value = action.payload;
    },
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload;
    },
  },
});

export const { increment, decrement, setValue, setSelectedPatient } =
  adminSlice.actions;
export default adminSlice.reducer;
